//libs
import { createBrowserRouter, Navigate } from "react-router-dom";
//features
import Home from "features/home/Home";
import Login from "features/auth/Login";
import TenderList from "features/tenders/TenderList/TenderList";
import SupplierRegister from "features/suppliers/SupplierRegister";
import TenderDetail from "features/tenders/TenderDetail/TenderDetail";
import SupplierRegistrationIndividual from "features/suppliers/SupplierRegistrationIndividual";
import SupplierRegistrationCorporate from "features/suppliers/SupplierRegistrationCorporate";
//layouts
import RootLayout from "layouts/layout";
//route
import ProtectedRoute from "./ProtectedRoute";
//features
import DashboardPage from "features/dashboard/DashboardPage";
import SupplierDirectoryPage from "features/supplier-directory/SupplierDirectoryPage";
import PricingPage from "features/suppliers/PricingPage";
import Notifications from "features/dashboard/Notifications";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "login", element: <Login /> },
      { path: "dashboard", element: <ProtectedRoute><DashboardPage /></ProtectedRoute> },
      { path: "notifications", element: <ProtectedRoute><Notifications /></ProtectedRoute> },
      { path: "pricing", element: <PricingPage /> },
      { path: "supplier-register", element: <SupplierRegister /> },
      {
        path: "supplier-directory",
        element: (
          <SupplierDirectoryPage />
        ),
      },
      {
        path: "supplier-register-individual",
        element: <SupplierRegistrationIndividual />,
      },
      {
        path: "supplier-register-corporate",
        element: <SupplierRegistrationCorporate />,
      },
      {
        path: "opportunities",
        element: (
          <TenderList />
        ),
      },
      {
        path: "tenders/:prefixedId",
        children: [
          {
            path: "overview",
            element: (
              <ProtectedRoute>
                <TenderDetail />
              </ProtectedRoute>
            ),
          },
          {
            path: "q&a",
            element: (
              <ProtectedRoute>
                <TenderDetail />
              </ProtectedRoute>
            ),
          },
          {
            path: "proposals",
            element: (
              <ProtectedRoute>
                <TenderDetail />
              </ProtectedRoute>
            ),
          },
          {
            index: true,
            element: <Navigate to="overview" replace />,
          },
        ],
      },
      {
        path: "quotations/:prefixedId",

        children: [
          {
            path: "overview",
            element: (
              <ProtectedRoute>
                <TenderDetail />
              </ProtectedRoute>
            ),
          },
          {
            path: "q&a",
            element: (
              <ProtectedRoute>
                <TenderDetail />
              </ProtectedRoute>
            ),
          },
          {
            path: "proposals",
            element: (
              <ProtectedRoute>
                <TenderDetail />
              </ProtectedRoute>
            ),
          },
          {
            index: true,
            element: <Navigate to="overview" replace />,
          },
        ],
      },
    ],
  },
]);
